import { StyleSheet, Platform } from "react-native";
import AppTheme from "../../AppTheme";

const headerStyles = StyleSheet.create({
  container: {
    minHeight: 88,
    backgroundColor: AppTheme.headerBg,
    zIndex: 1,
    justifyContent: "center",
    paddingBottom: 8,

    ...Platform.select({
      web: {
        paddingTop: 8,
      },
      ios: {
        paddingTop: 44,
      },
    }),
  },
  header: {
    position: "relative",
    display: "flex",
  },
  titleRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    minHeight: 40,
  },
  titleContainer: {
    width: "100%",
    paddingHorizontal: 50,
  },
  title: {
    textAlign: "left",
    color: AppTheme.title,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
  },
  leftContainer: {
    position: "absolute",
    left: 6,
    top: 0,
    height: "100%",
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  rightContainer: {
    position: "absolute",
    right: 6,
    top: 0,
    height: "100%",
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    minWidth: 40,
    minHeight: 40,
  },
  imageContainer: {
    position: "relative",
    width: 40,
    height: 40,
    borderRadius: 100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 40,
  },
  icon: {
    width: 20,
    height: 20,
  },
  gemContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  gemBg: {
    height: 40,
    width: 40,
    borderRadius: 100,
    borderWidth: 2,
    borderColor: AppTheme.DEFAULT_COLOR,
  },
  loading: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
  subTitleContainer: {
    marginTop: -5,
    marginLeft: 50,
  },
  subTitle: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.title,
  },
  weekContainer: {
    backgroundColor: AppTheme.weekContainer,
  },
  exitButton: {
    position: "absolute",
    top: 5,
    right: 5,
    backgroundColor: "#F4F6FA",
    borderRadius: 100,
    borderWidth: 1,
    borderColor: "#F4F6FA",
    zIndex: 1000,
    paddingHorizontal: 10,
  },
  exitButtonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#828282",
  },
  rightText: {
    maxWidth: 65,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#FFFFFF",
  },
});

export default headerStyles;
